import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { bookingResponse, BookingsResponse, savedListingsResponse } from "./interface";


interface inititalStateInterface {
    Bookings:BookingsResponse|null
    Booking:bookingResponse|null
    openReview:boolean
    savedListingsRessponse:savedListingsResponse | null
}

const initialState:inititalStateInterface ={
    Bookings:null,
    Booking:null,
    openReview:false,
    savedListingsRessponse:null
}

export const BookingSlice = createSlice({
    name:'Booking',
    initialState,
    reducers:{
        setBookings:(state:inititalStateInterface, action:PayloadAction<BookingsResponse>)=>{
            state.Bookings = action.payload
        },
        setBooking:(state:inititalStateInterface, action:PayloadAction<bookingResponse>)=>{
            state.Booking = action.payload
        },
        setOpenReview:(state:inititalStateInterface, action:PayloadAction<boolean>)=>{
            state.openReview = action.payload
        },
        setSavedListingsResponse:(state:inititalStateInterface, action:PayloadAction<savedListingsResponse>)=>{
            state.savedListingsRessponse = action.payload
        }
    }
})

export const {
    setBooking,
    setBookings,
    setOpenReview,
    setSavedListingsResponse
} = BookingSlice.actions